import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signOut } from '../lib/api';

export function SignOutSection() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      queryClient.clear();
      window.location.href = '/login';
    },
  });

  return (
    <div className="settings-section">
      <h3>Sign out</h3>
      <p>
        Signs out of the operator console on this device. CLI tokens stored in
        the OS Keyring are NOT affected — use <code>tizok logout</code> for that.
      </p>
      {mutation.isError && (
        <p className="settings-error" role="alert">
          Sign-out failed. Try again.
        </p>
      )}
      <div className="settings-actions">
        <button
          type="button"
          className="settings-action-primary settings-action-destructive"
          onClick={() => mutation.mutate()}
          disabled={mutation.isPending}
        >
          {mutation.isPending ? 'Signing out…' : 'Sign out'}
        </button>
      </div>
    </div>
  );
}
